(function () {
	var lastScrollY = window.scrollY;
	const header = document.querySelector(".site-header");

	document.addEventListener("DOMContentLoaded", () => {
		const menuToogle = document.querySelector("#menu-toggle");
		if (menuToogle) {
			menuToogle.addEventListener("click", toggleState);
			window.addEventListener("scroll", fixedMenu);
		}
	});

	function toggleState(e) {
		const button = e.target.closest("button");
		const isExpanded = button.getAttribute("aria-expanded") === "true";
		const controlled = document.getElementById(
			button.getAttribute("aria-controls")
		);
		controlled.classList.toggle("hidden");
		button.setAttribute("aria-expanded", !isExpanded);

		if (window.innerWidth < 800) {
			const spanAccount = document.querySelector(
				".site-header__nav-link--account span"
			);
			spanAccount.classList.toggle("visually-hidden");
		}

		if (window.innerWidth < 1100) {
			document.querySelector("body").style.overflow = isExpanded
				? "auto"
				: "hidden";
			document
				.querySelector("header.site-header")
				.classList.toggle("site-header-active-blur");
		}
	}

	function fixedMenu() {
		if (window.innerWidth < 800) {
			if (window.scrollY < lastScrollY) {
				header.classList.add("fixed");
			} else {
				header.classList.remove("fixed");
			}
			lastScrollY = window.scrollY;
		}
	}
})();
